/**
 * Single source of truth for total skills count.
 * Based on skills_catalog (27 active skills).
 * 
 * DO NOT CHANGE this value without updating both:
 * - skills_catalog table
 * - dvsa_skills table (to match)
 */
export const TOTAL_SKILLS = 27;

export const getTotalSkills = (): number => TOTAL_SKILLS;

/**
 * Dev-only warning if dvsa_skills count doesn't match expected total
 */
export const validateSkillsCount = (actualCount: number): void => {
  if (process.env.NODE_ENV === 'development' && actualCount !== TOTAL_SKILLS) {
    console.warn(
      `⚠️ Skills count mismatch: dvsa_skills has ${actualCount}, expected ${TOTAL_SKILLS}. ` +
      `This may cause incorrect progress calculations.`
    );
  }
};
